/* eslint-disable import/no-anonymous-default-export */
import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";
import environment from "environments/environment";

export default (input, callback) => {
  const mutation = graphql`
    mutation uploadCsvMutation($input: uploadCsvInput!) {
      uploadCsv(input: $input) {
        csvFile {
          name
          tempfile
          columnNames
          rowsCount
        }
      }
    }
  `;

  const variables = {
    input: input,
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: callback,
    onError: (err) => console.error("Api Error", err),
  });
};
